export const slugify = text => text.toString().toLowerCase().split(' ').join('-');

export const replaceAll = (text, from, to) => text.toString().split(from).join(to);
